export default __webpack_public_path__ + "static/media/Flyer-05.9cce59c1.jpg";